export const getConfiguration = async (status: string = 'PUBLISHED') => {
  try {
    const response = await fetch(
      process.env.NEXT_PUBLIC_GRAPHQL_API_ENDPOINT_CACHED +
        '/getconfiguration/' +
        status,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const data = await response.json();
    return data?.configuration;
  } catch (error) {
    console.error(error);
    return null;
  }
};
